// import axios from 'axios';
import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import axios from 'axios';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const getMyActionsByStatuses = async (requestPayload) => {
  try {
    const response = await axiosInstance.post(
      'Action/By/Statuses',
      requestPayload
    );
    return response.data;
  } catch (e) {
    throw new Error('Error getMyActionsByStatuses');
  }
};

const getActionByActionID = async ({ actionID }) => {
  try {
    const response = await axiosInstance.get(`/Action/ActionID/${actionID}`);
    return response.data;
  } catch (e) {
    throw new Error('Error getActionByActionID');
  }
};

const addNewAction = async (requestPayload) => {
  try {
    const response = await axiosInstance.post('Action/Add', requestPayload);
    return response.data;
  } catch (e) {
    throw new Error('Error getMyActionsByStatuses');
  }
};

// eslint-disable-next-line consistent-return
const updateActionInfo = async (requestPayload) => {
  try {
    const { ActionID } = requestPayload;
    const response = await axiosInstance.post(
      `Action/ActionID/${ActionID}/UpdateGeneralInfo`,
      requestPayload
    );
    return response.data;
  } catch (e) {
    if (axios.isCancel(e)) {
      console.log('Cancel updateActionInfo');
    } else {
      throw e;
    }
  }
};
// In Progress
const startAction = async ({ actionID }) => {
  try {
    const response = await axiosInstance.post(
      `/Action/ActionID/${actionID}/Start`
    );
    return response.data;
  } catch (e) {
    throw new Error('Error getMyActionsByStatuses');
  }
};

// Completed
const completeAction = async ({ actionID }) => {
  try {
    const response = await axiosInstance.post(
      `/Action/ActionID/${actionID}/Complete`
    );
    return response.data;
  } catch (e) {
    throw new Error('Error getMyActionsByStatuses');
  }
};

// Re-Open
const reopenAction = async ({ actionID }) => {
  try {
    const response = await axiosInstance.post(
      `/Action/ActionID/${actionID}/reopen`
    );
    return response.data;
  } catch (e) {
    throw new Error('Error getMyActionsByStatuses');
  }
};

const myActionsApi = {
  getMyActionsByStatuses,
  getActionByActionID,
  addNewAction,
  updateActionInfo,
  startAction,
  completeAction,
  reopenAction,
};

export default myActionsApi;
